const checkboxColors: object = {
  "blue-gray": {
    background: "checked:bg-blue-gray-500",
    border: "checked:border-blue-gray-500",
    before: "checked:before:bg-blue-gray-500",
  },
  gray: {
    background: "checked:bg-gray-900",
    border: "checked:border-gray-900",
    before: "checked:before:bg-gray-900",
  },
  brown: {
    background: "checked:bg-brown-500",
    border: "checked:border-brown-500",
    before: "checked:before:bg-brown-500",
  },
  "deep-orange": {
    background: "checked:bg-deep-orange-500",
    border: "checked:border-deep-orange-500",
    before: "checked:before:bg-deep-orange-500",
  },
  orange: {
    background: "checked:bg-orange-500",
    border: "checked:border-orange-500",
    before: "checked:before:bg-orange-500",
  },
  amber: {
    background: "checked:bg-amber-500",
    border: "checked:border-amber-500",
    before: "checked:before:bg-amber-500",
  },
  yellow: {
    background: "checked:bg-yellow-500",
    border: "checked:border-yellow-500",
    before: "checked:before:bg-yellow-500",
  },
  lime: {
    background: "checked:bg-lime-500",
    border: "checked:border-lime-500",
    before: "checked:before:bg-lime-500",
  },
  "light-green": {
    background: "checked:bg-light-green-500",
    border: "checked:border-light-green-500",
    before: "checked:before:bg-light-green-500",
  },
  green: {
    background: "checked:bg-green-500",
    border: "checked:border-green-500",
    before: "checked:before:bg-green-500",
  },
  teal: {
    background: "checked:bg-teal-500",
    border: "checked:border-teal-500",
    before: "checked:before:bg-teal-500",
  },
  cyan: {
    background: "checked:bg-cyan-500",
    border: "checked:border-cyan-500",
    before: "checked:before:bg-cyan-500",
  },
  "light-blue": {
    background: "checked:bg-light-blue-500",
    border: "checked:border-light-blue-500",
    before: "checked:before:bg-light-blue-500",
  },
  blue: {
    background: "checked:bg-blue-500",
    border: "checked:border-blue-500",
    before: "checked:before:bg-blue-500",
  },
  indigo: {
    background: "checked:bg-indigo-500",
    border: "checked:border-indigo-500",
    before: "checked:before:bg-indigo-500",
  },
  "deep-purple": {
    background: "checked:bg-deep-purple-500",
    border: "checked:border-deep-purple-500",
    before: "checked:before:bg-deep-purple-500",
  },
  purple: {
    background: "checked:bg-purple-500",
    border: "checked:border-purple-500",
    before: "checked:before:bg-purple-500",
  },
  pink: {
    background: "checked:bg-pink-500",
    border: "checked:border-pink-500",
    before: "checked:before:bg-pink-500",
  },
  red: {
    background: "checked:bg-red-500",
    border: "checked:border-red-500",
    before: "checked:before:bg-red-500",
  },
};

export default checkboxColors;
